import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';
import { galleryAPI } from '../api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { useToast } from '../hooks/use-toast';
import { Plus, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';

const AdminGallery = () => {
  const [gallery, setGallery] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    image: '',
    category: '',
  });
  const { toast } = useToast();

  useEffect(() => {
    loadGallery();
  }, []);

  const loadGallery = async () => {
    try {
      const response = await galleryAPI.getAll();
      setGallery(response.data);
    } catch (error) {
      toast({ title: 'Hata', description: 'Galeri yüklenemedi', variant: 'destructive' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await galleryAPI.create(formData);
      toast({ title: 'Başarılı', description: 'Görsel eklendi' });
      setIsDialogOpen(false);
      resetForm();
      loadGallery();
    } catch (error) {
      toast({ title: 'Hata', description: 'Görsel kaydedilemedi', variant: 'destructive' });
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu görseli silmek istediğinizden emin misiniz?')) {
      try {
        await galleryAPI.delete(id);
        toast({ title: 'Başarılı', description: 'Görsel silindi' });
        loadGallery();
      } catch (error) {
        toast({ title: 'Hata', description: 'Görsel silinemedi', variant: 'destructive' });
      }
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      image: '',
      category: '',
    });
  };

  return (
    <AdminLayout>
      <div>
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-white">Galeri Yönetimi</h1>
          <Button
            onClick={() => {
              resetForm();
              setIsDialogOpen(true);
            }}
            className="bg-[#FDB714] hover:bg-[#e5a510] text-black font-semibold"
          >
            <Plus size={20} className="mr-2" />
            Yeni Görsel
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {gallery.map((item) => (
            <Card key={item._id} className="bg-gray-900 border-gray-800 overflow-hidden">
              <img src={item.image} alt={item.title} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="text-white font-bold mb-1">{item.title}</h3>
                <p className="text-gray-500 text-sm mb-3">{item.category}</p>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handleDelete(item._id)}
                  className="w-full border-red-700 text-red-500 hover:bg-red-900/20"
                >
                  <Trash2 size={16} className="mr-1" />
                  Sil
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-2xl">
            <DialogHeader>
              <DialogTitle>Yeni Görsel Ekle</DialogTitle>
            </DialogHeader>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label>Başlık</Label>
                <Input
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  className="bg-gray-800 border-gray-700"
                  required
                />
              </div>

              <div>
                <Label>Görsel URL</Label>
                <Input
                  value={formData.image}
                  onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                  className="bg-gray-800 border-gray-700"
                  placeholder="https://example.com/image.jpg"
                  required
                />
              </div>

              <div>
                <Label>Kategori</Label>
                <Input
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  className="bg-gray-800 border-gray-700"
                  placeholder="Örn: Etkinlik, Film, Salon"
                  required
                />
              </div>

              <div className="flex gap-3 pt-4">
                <Button type="submit" className="flex-1 bg-[#FDB714] hover:bg-[#e5a510] text-black font-semibold">
                  Ekle
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => setIsDialogOpen(false)}
                  className="border-gray-700 text-gray-300 hover:bg-gray-800"
                >
                  İptal
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </div>
    </AdminLayout>
  );
};

export default AdminGallery;
